import { isAxiosError } from 'axios';

import { ApiError } from '../errors';

export const getIsNotFound = ({
  data,
  error,
  isLoading,
}: {
  data?: unknown;
  error?: unknown;
  isLoading?: boolean;
}): boolean => {
  if (isLoading) {
    return false;
  }

  if (isAxiosError(error)) {
    return error.response?.status === 404;
  }

  if (error instanceof ApiError) {
    return error.status === 404;
  }

  return !data;
};
